import React, { memo } from "react";
import { OfficeInfoStepProps } from "./types";
import { TextField } from "ui/components/TextField/TextField";
import { TextArea } from "ui/components/TextField/TextArea";
import { Dropdown } from "ui/components/Dropdown/Dropdown";
import { useHandleTextFieldChange, useHandleDropdownChange } from "services/forms/hooks";
import { OFFICE_STATUS_OPTIONS } from "services/api/offices/consts";

const OfficeInfoStep: React.FC<OfficeInfoStepProps> = ({
  formValues,
  setFormValues,
  errors,
}) => {
  const handleTextFieldChange = useHandleTextFieldChange(setFormValues, formValues);
  const handleDropdownChange = useHandleDropdownChange(setFormValues, formValues);

  return (
    <div className="flex items-center justify-center px-4 mt-8 xl:mt-16 min-h-[60vh] xl:min-h-[600px]">
      <div className="w-full max-w-4xl">
        <h1 className="text-2xl font-bold text-slate-900 text-center mb-1">Naziv poslovnice</h1>
        <p className="text-center text-sm text-slate-600 mb-6 max-w-2xl mx-auto ">
          Unesite osnovne podatke poslovnice.
          Nakon unosa možete nastaviti na sljedeći korak.
        </p>
        <div className="border border-slate-200 ">
          <div className=" py-6 px-4">
            <div className="flex items-center justify-between mb-3">
                  <h3 className="text-xs uppercase tracking-wide text-slate-400 font-semibold">Osnovni podaci</h3>
                <p className="text-xs text-slate-500">Unesite osnovne podatke poslovnice</p>
            </div>

            <div className="mb-3">
              <TextField
                type="text"
                name="name"
                label="Naziv"
                placeholder="Unesite naziv poslovnice"
                onChange={handleTextFieldChange}
                error={errors.name}
                value={formValues.name}
                required
                endIcon=""
              />
            </div>

            <div className="grid grid-cols-3 gap-3 mb-3">
              <div>
                <TextField
                  type="text"
                  name="code"
                  label="Šifra poslovnice"
                  placeholder="Unesite šifru poslovnice"
                  onChange={handleTextFieldChange}
                  error={errors.code}
                  value={formValues.code}
                  endIcon=""
                />
              </div>
              <div>
                <TextField
                  type="text"
                  name="internalMark"
                  label="Interna oznaka"
                  placeholder="Unesite internu oznaku"
                  onChange={handleTextFieldChange}
                  error={errors.internalMark}
                  value={formValues.internalMark}
                  endIcon=""
                />
              </div>
              <div>
                <Dropdown
                  name="status"
                  label="Status"
                  placeholder="Odaberite status"
                  onChange={handleDropdownChange}
                  error={errors.status}
                  value={formValues.status}
                  options={OFFICE_STATUS_OPTIONS}
                />
              </div>
            </div>

            <div>
              <TextArea
                name="description"
                label="Opis"
                placeholder="Unesite opis poslovnice"
                onChange={handleTextFieldChange}
                error={errors.description}
                value={formValues.description}
                rows={4}
                endIcon=""
              ></TextArea>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(OfficeInfoStep);
